import {XCSRF_TOKEN_HEADER} from 'common/constants';
import {refreshCsrfOnce} from './fetchCsrfToken';
import Token from './Token';
import {getErrors} from 'redux/common';

export const safeFetch = async (input: RequestInfo, init: RequestInit = {}): Promise<Response> => {
   const res = await fetch(input, {
      credentials: 'include',
      ...init,
      headers: {
         ...(init.headers || {}),
         [XCSRF_TOKEN_HEADER]: Token.getCsrfToken(),
      },
   });

   if (res.status === 403) {
      const errorRes = res.clone();
      const {message} = await getErrors(errorRes);

      if (String(message).toUpperCase().includes('CSRF')) {
         await refreshCsrfOnce();

         return fetch(input, {
            credentials: 'include',
            ...init,
            headers: {
               ...(init.headers || {}),
               [XCSRF_TOKEN_HEADER]: Token.getCsrfToken(),
            },
         });
      }
   }

   return res;
};
